export default __webpack_public_path__ + "static/media/spot_lesson_ticket.7ab5f974.png";